import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import PropTypes from "prop-types";
import InputMask from "react-input-mask";
import { Button } from "antd";

/**
 * این کامپوننت برای اینپوت های ساعت است
 */
export default function InputClock({
  label,
  name,
  defaultValue,
  disabled,
  handelValue,
  closable,
}) {
  const [time, setTime] = useState("");
  const [helper, setHelper] = useState(null);
  const [helperColor, setHelperColor] = useState(null);

  useEffect(() => {
    if (defaultValue) {
      setTime(defaultValue);
    }
  }, [defaultValue]);

  const clear = () => {
    setTime("");
    handelValue(name, "");
  };

  const handleChange = (e) => {
    const value = e.target.value;
    const array = value.split(":");
    setTime(value);
    if (array[0] > "23") {
      setHelper("ساعت باید کمتر از 24 باشد.");
      setHelperColor("red");
    } else if (array[1] > "59") {
      setHelper("دقیقه باید کمتر از 60 باشد.");
      setHelperColor("red");
    } else {
      setHelper("اطلاعات قابل ثبت است.");
      setHelperColor("green");
    }
    handelValue(name, e.target.value);
  };

  const clearButtonStyle = {
    color: "#919191",
    height: "3rem",
    marginTop: "2px",
    fontSize: "2rem",
    padding: "0 1rem 0 0",
  };

  return (
    <Form.Group>
      {label && <Form.Label>{label}</Form.Label>}
      <br />
      <div className='d-flex'>
        <InputMask
          mask='99:99'
          maskChar={"0"}
          dir='ltr'
          disabled={disabled}
          value={time}
          onChange={handleChange}
          style={{ height: "50px", width: "100%", border: "none !important" }}
        />
        {closable && <Button type='text' onClick={() => clear()} style={clearButtonStyle}>
          ×
        </Button>}
      </div>
      {helper && <Form.Text style={{ color: helperColor }}>{helper}</Form.Text>}
    </Form.Group>
  );
}

InputClock.propTypes = {
  /**لیبل اینپوت است */
  label: PropTypes.string,
  /**برای ارسال مقدار اولیه برای اینپوت است */
  defaultValue: PropTypes.string,
  /** مقدار هلدر اینپوت است */
  Placeholder: PropTypes.string,
  /** نام اینپوت است */
  name: PropTypes.string,
  /** ارسال مقدار اینپوت به بالا است */
  handelValue: PropTypes.func,
};
